import React from 'react'
import { Typography, Input, Row, Col, Collapse, Space, Button, Card } from 'antd'
import PropTypes from 'prop-types'
import { ImageUploader, RichTextContentEditor } from '~components'
import { getFileName } from '~utils'

import DownArrow from '../PositionArrows/DownArrow'
import UpArrow from '../PositionArrows/UpArrow'
import styles from './FAQModules.module.css'

const { Title } = Typography
const { TextArea } = Input
const { Panel } = Collapse

const FAQModules = ({ flexModules, setFlexModules, deleteAllFAQsImages, addNewFAQImage }) => {
  const deleteFAQ = (event, index) => {
    event.stopPropagation()
    const clonedflexModules = [...flexModules]
    if (index !== -1) {
      clonedflexModules.splice(index, 1)
    }
    setFlexModules(clonedflexModules)
  }

  const deleteFAQImage = (event, index, imageIndex) => {
    event.stopPropagation()

    const clonedflexModules = [...flexModules]

    const updatedImages = flexModules[index]?.images

    if (imageIndex !== -1) {
      updatedImages.splice(imageIndex, 1)
    }

    setFlexModules([
      ...clonedflexModules.slice(0, index),
      {
        ...clonedflexModules[index],
        images: updatedImages
      },
      ...clonedflexModules.slice(index + 1)
    ])
  }

  const handleHeaderChange = ({ target }, index) => {
    const clonedflexModules = [...flexModules]
    clonedflexModules[index] = {
      ...clonedflexModules[index],
      title: target.value
    }
    setFlexModules([...clonedflexModules])
  }

  const handleDescriptionChange = (description, index) => {
    const clonedflexModules = [...flexModules]
    clonedflexModules[index] = {
      ...clonedflexModules[index],
      html_description: description
    }
    setFlexModules([...clonedflexModules])
  }

  const handleImageLinkUpdate = (event, index, imageIndex) => {
    const clonedflexModules = [...flexModules]

    const images = flexModules[index]?.images

    const updatedImages = [
      ...images.slice(0, imageIndex),
      {
        ...images[imageIndex],
        href: event.target.value
      },
      ...images.slice(imageIndex + 1)
    ]

    setFlexModules([
      ...clonedflexModules.slice(0, index),
      {
        ...clonedflexModules[index],
        images: updatedImages
      },
      ...clonedflexModules.slice(index + 1)
    ])
  }

  const handleImageUrlUpdate = (secureImageURL, index, imageIndex) => {
    const clonedflexModules = [...flexModules]

    const images = flexModules[index]?.images
    const alt = getFileName(secureImageURL)

    const updatedImages = [
      ...images.slice(0, imageIndex),
      {
        ...images[imageIndex],
        url: secureImageURL,
        alt
      },
      ...images.slice(imageIndex + 1)
    ]

    setFlexModules([
      ...clonedflexModules.slice(0, index),
      {
        ...clonedflexModules[index],
        images: updatedImages
      },
      ...clonedflexModules.slice(index + 1)
    ])
  }

  const handleMoveUp = (event, id) => {
    event.stopPropagation()
    const clonedflexModules = [...flexModules]
    if (id > 0) {
      const el = clonedflexModules[id]
      clonedflexModules[id] = clonedflexModules[id - 1]
      clonedflexModules[id - 1] = el
      setFlexModules([...clonedflexModules])
    }
  }

  const handleMoveDown = (event, id) => {
    event.stopPropagation()
    const clonedflexModules = [...flexModules]
    if (id !== -1 && id < clonedflexModules.length - 1) {
      const el = clonedflexModules[id]
      clonedflexModules[id] = clonedflexModules[id + 1]
      clonedflexModules[id + 1] = el
      setFlexModules([...clonedflexModules])
    }
  }

  const deleteAllFAQImagesModules = (card, rowIndex) => card?.images?.length > 0 ? <Button className={styles.deleteActionButton} onClick={() => deleteAllFAQsImages(rowIndex)} style={{ backgroundColor: '#DA0D50', color: '#fff' }} type='danger'>
    Delete All
  </Button> : null

  const addFAQImageModule = (card, rowIndex) => <Button className={styles.updateActionButton} onClick={() => addNewFAQImage(card, rowIndex)} type='primary'>Add Image</Button>

  return (
    <div className={styles['content-card-container']}>
      <Collapse accordion defaultActiveKey={['0']} expandIconPosition='right' style={{ width: '100%' }}>
        {flexModules?.map((card, rowIndex) => (<Panel key={rowIndex}
          extra={<Row gutter={2}><Space>
            <Col align="left" span={4}>
              <Row gutter={[10]} style={{ width: '60px' }}>
                {rowIndex !== 0 && <Col align='right' data-testid="up-arrow" onClick={(event) => handleMoveUp(event, rowIndex)} span={12}>
                  <UpArrow />
                </Col>
                }
                {flexModules?.length - rowIndex !== 1
                  ? <Col align="left" data-testid="down-arrow" onClick={(event) => handleMoveDown(event, rowIndex)} span={12}>
                    <DownArrow />
                  </Col>
                  : <Col span={3} />}
              </Row>
            </Col>
            <Button danger onClick={(event) => deleteFAQ(event, rowIndex)} style={{ backgroundColor: '#DA0D50', color: '#fff' }}>Delete</Button>
          </Space>
          </Row>
          }
          header={<span style={{ fontSize: 20 }}>{card?.title}</span>}>
          <Row align={'left'} className={styles['title-wrapper']}>
            <Col><Title level={3}>Title*</Title></Col>
          </Row>
          <Row>
            <TextArea
              autoSize={{ minRows: 1 }}
              onChange={(e) => handleHeaderChange(e, rowIndex)}
              style={{ width: '100%' }}
              value={card?.title || ''}
            />
          </Row>
          <br />
          <Row align={'left'}>
            <Col><Title level={3}>Description</Title></Col>
          </Row>
          <Row style={{ minHeight: 120, height: '100%', width: '100%' }}>
            <RichTextContentEditor
              onChange={(description) => handleDescriptionChange(description, rowIndex)}
              value={card?.html_description || ''}
            />
          </Row>
          <Card key='11' extra={[deleteAllFAQImagesModules(card, rowIndex), addFAQImageModule(card, rowIndex)]} style={{
            fontSize: 20
          }} title='Images'>
            <Row>
              <Col span={24}>
                {card?.images?.map((image, imageIndex) => (<Row key={imageIndex} style={{ border: '1px solid', padding: 12 }}>
                  <Col span={24}>
                    <Button danger onClick={(event) => deleteFAQImage(event, rowIndex, imageIndex)} style={{ float: 'right', backgroundColor: '#DA0D50', color: '#fff', paddingBottom: 12 }}>Delete Image</Button>
                    <Row align={'left'} className={styles['title-wrapper']}>
                      <Col><Title level={3}>Link</Title></Col>
                    </Row>
                    <Row align={'left'} className={styles['title-wrapper']}>
                      <Input label={<Title level={3}>Section Header</Title>} onChange={(event) => handleImageLinkUpdate(event, rowIndex, imageIndex)} value={image?.href} /><br/>
                    </Row><br />
                    <Row align={'left'} className={styles['title-wrapper']}>
                      <ImageUploader handleUpload={(url) => handleImageUrlUpdate(url, rowIndex, imageIndex)} logoUrl={image?.url} pageType='tours' />
                    </Row>
                  </Col>
                </Row>))}
              </Col>
            </Row>
          </Card>
        </Panel>))
        }
      </Collapse>
    </div>
  )
}

FAQModules.propTypes = {
  addNewFAQImage: PropTypes.func,
  deleteAllFAQsImages: PropTypes.func,
  deleteFAQ: PropTypes.func,
  flexModules: PropTypes.array,
  setFlexModules: PropTypes.func
}

export default FAQModules
